// @ts-nocheck

    window.g_umi = {
      version: '3.2.28',
    };
  